<template>
  <v-container>
    <div class="title d-flex flex-column justify-center align-center mt-12">
      <img src="@core/assets/images/no_access_lock.png">
      <p class="mt-5 mb-1 secondary--font font-weight-600">
        It looks like you do not have access to this section.
      </p>
      <p class="body-2">
        <v-skeleton-loader v-if="loading">
        </v-skeleton-loader>
        <span v-else>
          Please talk to your 
          <span>{{ isCustomerManager ? 'Customer Success Manager' : 'Administrator' }}</span>
             to enable this function.
        </span>
      </p>
    </div>
  </v-container>
</template>
<script>
  import { $users,$invitations } from '@core/services/'
  import { mapGetters } from 'vuex'
  export default {
    data: ()=>{
      return {
        ownerId: null,
        isCustomerManager: false,
        loading: false
      }
    },
    computed: {
      ...mapGetters({
        account: 'auth/account',
        userData: 'auth/userdata'
      }),
    },
    mounted(){
      this.verifyAccount()
      this.isUserOwner();
    },
    methods: {
      async isUserOwner(){
        try{
          this.loading = true
          const [ownerData,UserInfoResponse] = await Promise.all([
            $invitations.getOwnerData(),
            $users.getInfo()
          ]) 

          let ownerId = ownerData.data.owner.id
          let userId = UserInfoResponse.data.user.id;
          if(ownerId == userId)
            this.isCustomerManager = true
        }
        finally{
          this.loading = false
        }
      },

      verifyAccount(){
        let account_id = this.account.current && "id" in this.account.current && this.account.current.id
        if(!account_id){
          return;
        }
        $users.getAllAccountList({
          params: {
            id_eq: account_id
          }
        }).then((response)=>{
          let {data} = response.data;
          if( data != null && data.length){
            return;
          }

          this.removeCurrentAccount();
  
        }).catch(err => {
          this.loading.active = false;
          this.loading.message = this.messages.failed;
        })
      },
      removeCurrentAccount(){
        let account_id = this.account.current.id
        let index = this.account.list.findIndex( (i) => i.id == account_id );
        this.account.list.splice(index,1);
        this.$store.commit('auth/account.list', this.account.list)
        this.setBaseAccount();
      },
      setBaseAccount(){
        if(this.account.list.length == 0){
          let status = 400;
          let message = `No linked account found for this user. Kindly Contact Admin.`;
          let url = `${this.$config.MAROPOST_IDENTITY_BASE_URL}/#/dashboard?code=${status}&message=${message}`;
          window.location.href = url;
        }else{
          this.$store.commit('auth/account.id', this.account.list[0].id)
        }
      }
    }
  }
  </script>